import { handleSourcingSharedJobInformationBackController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedJobInformationBackController';
import { handleSourcingSharedJobInformationNextController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedJobInformationNextController';
import { handleSourcingSharedChooseChannelBackController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedChooseChannelBackController';
import { handleSourcingSharedSetupApplicationBackController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedSetupApplicationBackController';
import { handleSourcingSharedSetupApplicationNextController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedSetupApplicationNextController';
import { handleSourcingSharedCustomizeMessageNextController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedCustomizeMessageNextController';
import { handleSourcingSharedCustomizeMessageBackController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedCustomizeMessageBackController';
import { handleSourcingSharedOnReviewInvitationsBackController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedOnReviewInvitationsBackController';
import { handleSourcingSharedInviteSubmitController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedInviteSubmitController';
import { handleSourcingSharedCustomizeMessageInviteSubmitController } from 'modules/sourcing-shared/controllers/store-controllers/handleSourcingSharedCustomizeMessageInviteSubmitController';
import { generateStartingTemplatedMessageController } from 'modules/sourcing-shared/controllers/generateStartingTemplatedMessageController';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types/sharedSourcingStoreApi';
import { SourcingSharedStoreActions } from 'modules/sourcing-shared/shared-stores/types';

type CreateSharedSourcingStoreMethodsProps = {
  get: SharedSourcingStoreApi['getState'];
  set: SharedSourcingStoreApi['setState'];
};

export const createSharedSourcingStoreMethods = ({
  get,
  set
}: CreateSharedSourcingStoreMethodsProps): Omit<
  SourcingSharedStoreActions,
  // Omit these functions as they are handled differently
  // This is because internal sourcing has selectedCandidateProfiles
  // and external sourcing has selectedSourcedCandidates
  | 'onSelectedCandidatesNext'
  | 'onSelectedCandidatesBack'
  | 'updateSelectedRowCustomMessage'
  | 'onChooseChannelNext'
> => ({
  onGenerateStartingTemplatedMessage: async ({ candidateBatch, channel }) => {
    await generateStartingTemplatedMessageController({
      get,
      set,
      jobDescription: candidateBatch.jobDescription,
      jobTitle: candidateBatch.jobDescriptionParsed?.jobTitle,
      employerName: candidateBatch.jobDescriptionParsed?.employerName,
      channel
    });
  },
  onChooseChannelBack: () =>
    handleSourcingSharedChooseChannelBackController({
      set
    }),
  onJobInformationNext: (jobInformationFormData) =>
    handleSourcingSharedJobInformationNextController({
      jobInformationFormData,
      set
    }),
  onJobInformationBack: (props) =>
    handleSourcingSharedJobInformationBackController({
      ...props,
      set
    }),
  onSetupApplicationNext: (applicationFormData) =>
    handleSourcingSharedSetupApplicationNextController({
      applicationFormData,
      get,
      set
    }),
  onSetupApplicationBack: () =>
    handleSourcingSharedSetupApplicationBackController({
      set
    }),
  onCustomizeMessageNext: (data) =>
    handleSourcingSharedCustomizeMessageNextController({
      ...data,
      get,
      set
    }),
  onCustomizeMessageBack: (props: {
    integrationCredentials: { provider?: string | null } | null;
    portalUrl: string | undefined | null;
  }) =>
    handleSourcingSharedCustomizeMessageBackController({
      set,
      get,
      ...props
    }),
  onCustomizeMessageInviteSubmit: (data) =>
    handleSourcingSharedCustomizeMessageInviteSubmitController({
      ...data,
      get,
      set
    }),
  onReviewInvitationsBack: () =>
    handleSourcingSharedOnReviewInvitationsBackController({
      set
    }),
  setSelectedCustomizeCandidateId: (candidateId) =>
    set({
      selectedCustomizeCandidateId: candidateId
    }),
  onInviteSubmit: (payload) =>
    handleSourcingSharedInviteSubmitController({
      payload,
      get,
      set
    })
});
